<template>

  <!--红包人物-->
  <div class="alert-box person-red-envelopes">
    <p @click="closeFun" class="mask"></p>
    <div class="alert-box-con-red">
      <img class="red-envelopes-img" :src="personEnvelopes.picture" alt="">
      <img class="red-envelopes-logo" src="../assets/red-envelopes-logo.png" alt="">

      <div class="person-red-envelopes-bot border-box">
        <img @click="closeFun" class="red-envelopes-close" src="../assets/red-envelopes-close.png" />
        <div class="person-red-envelopes-con">
          <p class="person-red-envelopes-text1">恭喜你获得现金抵用红包</p>
          <p class="person-red-envelopes-text2">{{ personEnvelopes.money }}
            <span>元</span>
          </p>
          <p class="person-red-envelopes-text3">购买景区解说专辑优惠立减</p>
          <p @click="goVideoPlay(personEnvelopes.url)" class="person-red-envelopes-btn">立即使用</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  import {getCouponAtRandom} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        TimeStamp: new Date().getTime(),  //获取当前时间
      }
    },
    created(){

    },
    props: ['personEnvelopes','shopid'],
    computed: {

    },
    methods: {
      //关闭弹窗
      closeFun(){
        this.$emit('close',{redEnvelopes: [], personEnvelopes: [], recommendPerson: ""});
      },

      //跳转到专辑详情页
      goVideoPlay(url){
        let id = url.split("id=")[1];
        this.$router.push({
          path: `/video-play?${'id='+ id +'&spotid=&shopid='+ this.shopid + '&TimeStamp='+ this.TimeStamp}`
        });
      },

    },
  }
</script>

<style scoped>

  @import '../style/alert';

</style>



// WEBPACK FOOTER //
// src/components/AlertPersonEnvelope.vue